import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import useMediaQuery from '@mui/material/useMediaQuery';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';
import TokenExpiryHandler from '../../utils/TokenExpiryHandler';

// project imports
import Drawer from './Drawer';
import Header from './Header';
import Footer from './Footer';
import Loader from 'components/Loader';
import Breadcrumbs from 'components/@extended/Breadcrumbs';

import { handlerDrawerOpen, useGetMenuMaster } from 'api/menu';

// ==============================|| MAIN LAYOUT ||============================== //

export default function DashboardLayout() {
  const { menuMaster, menuMasterLoading } = useGetMenuMaster();
  const downXL = useMediaQuery((theme) => theme.breakpoints.down('xl'));
  const isFocusMode = menuMaster?.isFocusMode;

  // set media wise responsive drawer
  useEffect(() => {
    handlerDrawerOpen(!downXL);
  }, [downXL]);

  if (menuMasterLoading) return <Loader />;

  // Focus mode hides Header/Drawer/Footer as sibling elements rather than
  // early-returning a differently-shaped tree — <Outlet /> must stay at the
  // same position across the toggle, or React unmounts/remounts the routed
  // page (resetting all its state and re-firing every fetch on toggle).
  return (
    <>
      <TokenExpiryHandler />
      {/* height (not minHeight) + overflow:hidden makes this a fixed viewport
          shell: Header is position:fixed (see Header/index.jsx) so it floats
          above this column without taking flow space; the row below and the
          Footer are its only two flex children, sized to exactly fill the
          rest of the viewport. Only <main> scrolls internally — Drawer and
          Footer stay put regardless of how tall the routed page's content is. */}
      <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'hidden' }}>
        {!isFocusMode && <Header />}
        <Box sx={{ display: 'flex', width: '100%', flex: 1, minHeight: 0, overflow: 'hidden' }}>
          {!isFocusMode && <Drawer />}

          <Box
            component="main"
            sx={{
              flexGrow: 1,
              minWidth: 0,
              minHeight: 0,
              display: 'flex',
              flexDirection: 'column',
              overflowY: 'auto',
              p: isFocusMode ? 0 : { xs: 1, sm: 1 }
            }}
          >
            {!isFocusMode && <Toolbar sx={{ mt: 'inherit', flexShrink: 0 }} />}
            <Box
              sx={{
                ...{ px: { xs: 0, sm: 0 } },
                position: 'relative',
                flex: 1,
                minHeight: 0,
                display: 'flex',
                flexDirection: 'column'
              }}
            >
              {/* <Breadcrumbs /> */}
              <Outlet />
            </Box>
          </Box>
        </Box>
        {!isFocusMode && <Footer />}
      </Box>
    </>
  );
}
